import { request } from '@/utils/request'
import { COMMON_API } from './registry'

/**
 * 认证接口 —— 对应旧 login.js 的 /login 与 common.js logout() 的 /logout
 */

export interface LoginParams {
  userName: string
  /** 已做 MD5 的密码 */
  password: string
  verifyCode?: string
}

export interface LoginResult {
  success: string
  accessToken: string
  user: Record<string, any>
  infoMap: Record<string, any>
  type?: string
}

/** 登录 */
export function login(params: LoginParams) {
  return request<LoginResult>(COMMON_API.login, params)
}

/** 退出登录（旧 logout 接口，返回字符串 'SUCCESS'） */
export function logout() {
  return request<string>(COMMON_API.logout)
}
